module.exports = __webpack_public_path__ + "img/explosion-gunshot.94da4ac6.png";